import {
  REAL_NAME_VERIFY,
  CLEAR_REAL_NAME_VERIFY,
  BANKCARD_DATA,
} from './actions';

const initialState = {};

export default function RealNameVeriifyReducer(state = initialState, action) {
  switch (action.type) {
    case REAL_NAME_VERIFY:
      return Object.assign({}, state, {
        realNameVerifyResult: action.realNameVerifyResult,
      });
    case CLEAR_REAL_NAME_VERIFY:
      return Object.assign({}, state, { realNameVerifyResult: {} });
    case BANKCARD_DATA:
      return Object.assign({}, state, {
        bankcarddata: action.bankcarddata,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/realNameVerify/modules/realNameVerify.js